/* globals FB */

import { userService } from '@/services/user-service';
import { router } from '@/router';
import Vue from '@/main';

const savedUser = userService.retrieve();
const initialState = savedUser ? { status: { loggedIn: true }, user: savedUser } : { status: {}, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    getAuthStatus(state) {
      return state.status;
    },
  },
  actions: {
    login({ rootState, commit, dispatch }, { email, password }) {
      const brand = rootState.brand.brandID;
      commit('loginRequest', { email });

      userService.login(email, password, brand)
        .then((user) => {
          commit('loginSuccess', user.data);
          userService.postLoginRedirect();
          dispatch('alert/clear', '', { root: true });
        })
        .catch(error => dispatch('loginError', error.response.data));
    },
    logout({ dispatch, commit }, prevent) {
      userService.logout();
      FB.logout(() => {});
      Vue.$gAuth.signOut();
      dispatch('modal/setModalMode', 'logged-out', { root: true });
      dispatch('user/resetUserInfo', '', { root: true });
      commit('logout');
      if (!prevent) {
        router.push('/');
      }
    },
    googleSignIn({ commit }, token) {
      commit('loginRequest', { token });
      const brand = rootState.brand.brandID;

      userService
        .gLogin(token, brand)
        .then((user) => {
          commit('loginSuccess', user.data);
          userService.postLoginRedirect();
        })
        .catch(error => this.loginError(error));
    },
    facebookSignIn({ commit }) {
      const brand = rootState.brand.brandID;

      FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          userService
            .fbLogin(response.authResponse.accessToken, brand)
            .then((user) => {
              commit('loginSuccess', user.data);
              userService.postLoginRedirect();
            })
            .catch(error => this.loginError(error));
        } else {
          FB.login((logRes) => {
            if (logRes.status === 'connected') {
              userService
                .fbLogin(logRes.authResponse.accessToken, brand)
                .then((user) => {
                  commit('loginSuccess', user.data);
                  userService.postLoginRedirect();
                })
                .catch(error => this.loginError(error));
            } else {
              commit('loginFailure', response.authResponse);
              userService.logout();
            }
          }, { scope: 'email' });
        }
      });
    },
    loginError({ commit, dispatch }, error) {
      commit('loginFailure', error);
      dispatch('alert/error', error.message, { root: true });
    },
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, login) {
      state.status = { loggedIn: true };
      state.user = login;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    },
  },
};
